module.exports = __webpack_public_path__ + "img/86084862.3a2cdf58.png";